import { useEffect, useRef } from "react";
import { API } from "@/lib/api";

// Personal websocket: incoming-call rings and cancellations for every room you belong to.
export function useUserSocket(enabled, onEvent) {
  const handlerRef = useRef(onEvent);
  handlerRef.current = onEvent;

  useEffect(() => {
    if (!enabled) return;
    let ws;
    let retry;
    let closed = false;

    const open = () => {
      const token = localStorage.getItem("cml_token") || "";
      const url = `${API.replace(/^http/, "ws")}/ws/me?token=${encodeURIComponent(token)}`;
      try {
        ws = new WebSocket(url);
      } catch (err) {
        console.error("Could not open the personal socket:", err);
        return;
      }
      ws.onmessage = (e) => {
        try {
          handlerRef.current?.(JSON.parse(e.data));
        } catch (err) {
          console.error("Personal socket sent a malformed message:", err);
        }
      };
      ws.onclose = () => {
        if (!closed) retry = setTimeout(open, 4000);
      };
    };

    open();
    return () => {
      closed = true;
      clearTimeout(retry);
      try {
        ws?.close();
      } catch {
        /* already closed by the browser */
      }
    };
  }, [enabled]);
}
